module.exports = __webpack_public_path__ + "UX37.png?bf8da7efb00aa2224e4813b0ed58eb0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX37.png
// module id = 87
// module chunks = 0